import { useEffect, useState } from 'react';
import { useHandleError, useStudyPeriodList, useDisciplineList, useEmpStatusAbbrList } from '@/hooks';

export const useFilterWorkloadData = (schoolId: number) => {
  const handleError = useHandleError();
  const [isFilterWorkloadDataLoading, setIsFilterWorkloadDataLoading] = useState(true);
  const {
    data: studyPeriodList = [],
    isLoading: isStudyPeriodListLoading,
    error: studyPeriodListError,
  } = useStudyPeriodList(schoolId);
  const {
    data: disciplineList = [],
    isLoading: isDisciplineLoading,
    error: disciplineListError,
  } = useDisciplineList(schoolId);
  const {
    data: empStatusAbbrList = [],
    isLoading: isEmpStatusAbbrListLoading,
    error: empStatusAbbrListError,
  } = useEmpStatusAbbrList(schoolId);

  useEffect(() => {
    setIsFilterWorkloadDataLoading(isDisciplineLoading || isStudyPeriodListLoading || isEmpStatusAbbrListLoading);
  }, [isDisciplineLoading, isStudyPeriodListLoading, isEmpStatusAbbrListLoading]);

  useEffect(() => {
    if (disciplineListError || studyPeriodListError || empStatusAbbrListError) {
      console.error('Error fetching data:', { disciplineListError, studyPeriodListError, empStatusAbbrListError });
    }
    handleError([disciplineListError, studyPeriodListError, empStatusAbbrListError]);
  }, [disciplineListError, studyPeriodListError, empStatusAbbrListError, handleError]);

  return {
    studyPeriodList,
    disciplineList,
    empStatusAbbrList,
    isFilterWorkloadDataLoading,
  };
};
